import React, { useState } from "react";
import axios from "axios";


const useUserFeedback = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [userFeedbackOption, setUserFeedbackOption] = useState([])
    const mainApi = '/system/news_self/user_feedback'
    const getUserFeedbackOption = ({news_id,feed_back_type_id}) => {
        axios.get(mainApi, {
            params: {
                news_id,
                feed_back_type_id
            }
        })
            .then((response) => {
                let data = response.data.data
                data = data.map((value) => {
                    return {
                        label: value?.news_type_name,
                        value: value?.news_type_id,
                        ...value
                    }
                })
                setUserFeedbackOption(data)
            });
    }
    const getUserFeedbackData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postUserFeedbackData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchUserFeedbackData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "failure") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteUserFeedbackData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        userFeedbackOption: userFeedbackOption,
        // userFeedbackData: data,
        // getUserFeedbackData,
        getUserFeedbackOption,
        // postUserFeedbackData,
        // patchUserFeedbackData,
        // deleteUserFeedbackData,
    }
}
export { useUserFeedback }
